import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "uncompleted-check",
  "use": "uncompleted-check-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"uncompleted-check\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-2h24v24H-2V-2zm0 0h24v24H-2V-2z\" /><path fill=\"#000\" d=\"M14.59 5.58 8 12.17 4.41 8.59 3 10l5 5 8-8-1.41-1.42zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol